import React, { useEffect, useState } from "react";
import { Grid, Container, Modal } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { requestADemoAsync } from "features/actions/auth";
import ReCAPTCHA from "react-google-recaptcha";
import CheckIcon from "@mui/icons-material/Check";
const DemoRequestForm = () => {
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const [isLocalhost, setIsLocalhost] = useState(false);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCaptchaChange = (value) => {
    setIsCaptchaVerified(true);
  };
  const validate = () => {
    let newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    if (!formData.company.trim())
      newErrors.company = "Company Name is required";
    if (!isCaptchaVerified) newErrors.captcha = "Please verify the CAPTCHA";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Submitted Data:", formData);
    if (!validate()) {
      return;
    }
    const form = new FormData();
    form.append("name", formData.name.trim());
    form.append("email", formData.email.trim());
    form.append("company_name", formData.company.trim());

    try {
      dispatch(requestADemoAsync(form)).then(() => {
        setOpen(true);
        setFormData({ name: "", email: "", company: "" });
      });
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  useEffect(() => {
    const isLocal = window.location.hostname === "localhost";
    setIsLocalhost(isLocal);
  }, []);
  return (
    <MDBox
      sx={{
        width: { xs: "90%", sm: "100%", md: "78.5%" },
        m: "auto",
        ml: "auto",
        // mr: "9.5%",
      }}
    >
      <MDBox
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          mb: {
            xs: 0,
            sm: 3,
            md: 5,
          },
        }}
      >
        <MDTypography
          sx={{
            fontWeight: {
              xs: 400,
              sm: 600,
              md: 600,
            },
            fontSize: {
              xs: "15px",
              sm: "16px",
              md: "38px",
            },
            color: "#000",
            fontFamily: "Poppins",
            lineHeight: "20px",
          }}
        >
          Request a Demo
        </MDTypography>
      </MDBox>
      <MDTypography
        variant="h4"
        sx={{
          display: {
            xs: "blcok",
            sm: "none",
            md: "none",
          },
          mb: 4.4,
          fontSize: "16px",
          color: "#000",
          fontFamily: "Poppins",
          fontSize: "20px",
          lineHeight: "20px",
          fontWeight: 600,
          textAlign: "center",
        }}
        gutterBottom
      >
        Book 1:1 with Expert
      </MDTypography>
      <MDBox
        sx={{
          borderRadius: { xs: "10px", sm: "15px", md: "15px" },
          overflow: "hidden",
          p: { xs: 1.5, sm: 4, md: 4 },
          backgroundColor: "#ffff",
          boxShadow: "6px 4px 15px 8px #00000040",
        }}
      >
        <Grid container spacing={4}>
          {/* Left Side Content */}
          <Grid item xs={12} md={6}>
            <MDBox
              maxWwidth="100%"
              height="100%"
              display="flex"
              flexDirection="column"
              justifyContent="start"
              alignItems="start" // ✅ Center content
              textAlign="start"
              sx={{
                display: {
                  xs: "none",
                  sm: "block",
                  md: "block",
                },
                borderRight: { md: "2px solid gray", xs: "none" }, // ✅ center border
                pr: { md: 8, xs: 0 },
                pl: { md: 2, xs: 0 },
                mb: { xs: 4, md: 0 },
                pt: { md: 4.5, xs: 0 },
              }}
            >
              <MDTypography
                variant="h4"
                sx={{
                  mb: 4.4,
                  fontSize: "28px",
                  color: "#000",
                  fontFamily: "Poppins",
                  fontSize: "29px",
                  lineHeight: 1.4,
                  fontWeight: 600,
                }}
                gutterBottom
              >
                Book 1:1 with Expert
              </MDTypography>
              <MDTypography
                variant="body1"
                sx={{
                  mb: 3,
                  fontSize: "16px",
                  fontFamily: "urbanist",
                  color: "#000",
                  fontFamily: "Poppins",
                  lineHeight: 1.5,
                }}
                color="text.secondary"
              >
                See how our AI-powered restaurant marketing platform boosts
                reviews and revenue fast.
              </MDTypography>
              <MDTypography
                variant="body1"
                sx={{
                  mb: 3,
                  fontSize: "16px",
                  color: "#000",
                  fontFamily: "Poppins",
                  lineHeight: 1.4,
                }}
                color="text.secondary"
              >
                Explore local and guest intelligence tailored to your business.
              </MDTypography>
              <MDTypography
                variant="body1"
                sx={{
                  mb: 1,
                  fontSize: "16px",
                  color: "#000",
                  fontFamily: "Poppins",
                  lineHeight: 1.4,
                }}
                color="text.secondary"
              >
                Request a free demo and turn insights into action with TavloAI.
              </MDTypography>
            </MDBox>
          </Grid>

          {/* Right Side Form */}
          <Grid item xs={12} md={6}>
            <form
              onSubmit={handleSubmit}
              disabled={!isLocalhost && !isCaptchaVerified}
            >
              <MDBox
                display="flex"
                flexDirection="column"
                gap={1}
                sx={{
                  pl: { md: 6, xs: 1 },
                  pr: { md: 4, xs: 1 },
                  py: { md: 4, xs: 0 },
                }}
              >
                {/* Name */}
                <MDBox sx={{ mb:  { xs: 1, sm: 1.7, md: 1.7 }, }}>
                  <MDTypography
                    variant="subtitle2"
                    sx={{
                      color: "#212121",
                      fontFamily: "Poppins",
                      fontSize: { xs: "13px", sm: "14px", md: "15px" },
                      fontWeight: 300,
                      lineHeight: { xs: 0.5, sm: 0.6, md: 0.6 },
                    }}
                  >
                    Name
                  </MDTypography>

                   <MDBox
                    component="input"
                    name="name"
                    type="text"
                    value={formData.name}
                    onChange={handleChange}
                    sx={{
                       my: { xs: 0.5, sm: 1, md: 1 },
                      width: "100%",
                      borderRadius: { xs: "6px", sm: "10px", md: "10px" },
                      padding: {
                        xs: "7px 10px",
                        sm: "10px 14px",
                        md: "10px 15px",
                      },
                      fontSize: { xs: "10px", sm: "12px", md: "16px" },
                      border: "1px solid #828181ff",
                      outline: "none",
                      transition: "border-color 0.3s ease",
                      "&:focus": {
                        border: "2px solid blue",
                      },
                    }}
                  />
                  {errors.name && (
                    <MDTypography
                      sx={{ color: "red", fontSize: "12px", mt: 0.5 }}
                    >
                      {errors.name}
                    </MDTypography>
                  )}
                </MDBox>

                {/* Email */}
                <MDBox sx={{ mb:  { xs: 1, sm: 1.7, md: 1.7 } }}>
                  <MDTypography
                    variant="subtitle2"
                    sx={{
                      color: "#212121",
                      fontFamily: "Poppins",
                      fontSize: { xs: "13px", sm: "14px", md: "15px" },
                      fontWeight: 300,
                      lineHeight: { xs: 0.5, sm: 0.6, md: 0.6 },
                    }}
                  >
                    Email
                  </MDTypography>

                  <MDBox
                    component="input"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    sx={{
                      my: { xs: 0.5, sm: 1, md: 1 },
                      width: "100%",
                      borderRadius: { xs: "6px", sm: "10px", md: "10px" },
                      padding: {
                        xs: "7px 10px",
                        sm: "10px 14px",
                        md: "10px 15px",
                      },
                      fontSize: { xs: "10px", sm: "12px", md: "16px" },
                      border: "1px solid #828181ff",
                      outline: "none",
                      transition: "border-color 0.3s ease",
                      "&:focus": {
                        border: "2px solid blue",
                      },
                    }}
                  />
                  {errors.email && (
                    <MDTypography
                      sx={{ color: "red", fontSize: "12px", mt: 0.5 }}
                    >
                      {errors.email}
                    </MDTypography>
                  )}
                </MDBox>

                {/* Company Name */}
                <MDBox>
                  <MDTypography
                    variant="subtitle2"
                    sx={{
                      color: "#212121",
                      fontFamily: "Poppins",
                      fontSize: { xs: "13px", sm: "14px", md: "15px" },
                      fontWeight: 300,
                      lineHeight: { xs: 0.5, sm: 0.6, md: 0.6 },
                    }}
                  >
                    Company Name
                  </MDTypography>

                  
                  <MDBox
                    component="input"
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    sx={{
                      my: { xs: 0.5, sm: 1, md: 1 },
                      width: "100%",
                      borderRadius: { xs: "6px", sm: "10px", md: "10px" },
                      padding: {
                        xs: "7px 10px",
                        sm: "10px 14px",
                        md: "10px 15px",
                      },
                      fontSize: { xs: "10px", sm: "12px", md: "16px" },
                      border: "1px solid #828181ff",
                      outline: "none",
                      transition: "border-color 0.3s ease",
                      "&:focus": {
                        border: "2px solid blue",
                      },
                    }}
                  />

                  {errors.company && (
                    <MDTypography
                      sx={{ color: "red", fontSize: "12px", mt: 0.5 }}
                    >
                      {errors.company}
                    </MDTypography>
                  )}
                </MDBox>

                <MDBox
                  item
                  xs={12}
                  lg={12}
                  sx={{ alignSelf: "start", justifyContent: "center" }}
                >
                  {!isLocalhost && (
                    <ReCAPTCHA
                      sitekey="6Ldp3lspAAAAAPZoobA6vLHHHOnWa4eTm9B-GyxB"
                      onChange={handleCaptchaChange}
                    />
                  )}
                  {errors.captcha && (
                    <MDTypography
                      sx={{ color: "red", fontSize: "12px", mt: 0.5 }}
                    >
                      {errors.captcha}
                    </MDTypography>
                  )}
                </MDBox>

                <MDBox
                  component="button"
                  type="submit"
                  sx={{
                    border: "none",
                    backgroundColor: "#000",
                    color: "#fff",
                    mt: 1.7,
                    mb: { xs: 1.7, sm: 0, md: 0 },
                    borderRadius: { xs: "3px", sm: "7px", md: "7px" },
                    width: "fit-content",
                    fontSize: { xs: "10px", sm: "14px", md: "15px" },
                    lineHeight: { xs: "20px", sm: "auto", md: "auto" },
                    fontWeight: 600,
                    textTransform: "none",
                    fontFamily: "Poppins",
                    px: 2,
                    py: { xs: 0.5, sm: 2, md: 1.5 },
                    textAlign: "center",
                    fontFamily: "Poppins",
                  }}
                >
                  Book a Demo
                </MDBox>
              </MDBox>
            </form>
          </Grid>
        </Grid>
      </MDBox>

      {/* Modal  */}
      <Modal open={open} onClose={() => setOpen(false)}>
        <MDBox
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            p: 4,
            borderRadius: "8px",
            boxShadow: 24,
            width:{ xs: "300px", sm: 400, md: 400 } ,
            height: { xs: "240px", sm: "300px", md: "300px" },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <MDBox
            sx={{
              position: "absolute",
              top: "-25px",
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#21BA02",
              borderRadius: "50%",
              boxShadow: 3,
              width: "60px",
              height: "60px",
              fontSize: "40px",
            }}
          >
            <CheckIcon sx={{ fontSize: "40px", color: "#fff" }} />{" "}
          </MDBox>

          <MDTypography
            variant="h3"
            component="h2"
            sx={{ fontFamily: "Poppins", color: "#000" }}
          >
            Submitted!
          </MDTypography>

          <MDTypography
            sx={{
              mt: 2,
              fontFamily: "Poppins",
              color: "#000",
              fontSize: "16px",
            }}
          >
            TavloAI team will contact you soon. Thanks!
          </MDTypography>

          <MDBox
            component="button"
            onClick={() => setOpen(false)}
            sx={{
              border: "none",
              backgroundColor: "#F47C00",
              color: "#fff",
              mt: 3,
              borderRadius: { xs: "3px", sm: "7px", md: "7px" },
              fontSize: { xs: "10px", sm: "14px", md: "15px" },
              fontWeight: 600,
              textTransform: "none",
              fontFamily: "Poppins",
              px: { xs: 2, sm: 3, md: 5.5 },
              py: { xs: 0.5, sm: 1, md: 1 },
            }}
          >
            OK
          </MDBox>
        </MDBox>
      </Modal>
    </MDBox>
  );
};

export default DemoRequestForm;
